import React from 'react';
import { FaGithub, FaLinkedin, FaCodepen } from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi';

const SocialLinks = () => {
  const links = [
    {
      id: 1,
      child: (
        <>
          LinkedIn <FaLinkedin size={30} />
        </>
      ),
      href: 'https://www.linkedin.com/in/utkarsh-shahare-7b4109214/',
      style: 'rounded-tr-md',
    },
    {
      id: 2,
      child: (
        <>
          GitHub <FaGithub size={30} />
        </>
      ),
      href: 'https://github.com/utkarsh2004git',
    },
    {
      id: 3,
      child: (
        <>
          Mail <HiOutlineMail size={30} />
        </>
      ),
      href: 'mailto:foo@gmail.com',
    },
    {
      id: 4,
      child: (
        <>
          CodePen <FaCodepen size={30} />
        </>
      ),
      href: 'https://codepen.io/utkarsh_001122',
      style: 'rounded-br-md',
    },
  ];

  return (
    <div className='z-10 hidden lg:flex flex-col top-[35%] left-0 fixed'>
      <ul>
        {links.map(({ id, child, href, style }) => (
          <li
            key={id}
            className={
              'ml-[-100px] hover:ml-[-10px] duration-300 hover:rounded-md flex justify-between items-center w-40 h-14 px-4  bg-white/10 backdrop-blur-sm hover:bg-white/30' +
              ' ' +
              style
            }
          >
            <a href={href} target="_blank" rel="noreferrer" className='flex justify-between items-center w-full text-white'>
              {child}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SocialLinks;
